import { useEffect, useRef, useState } from "react";

export const VendorProductSearchSelect = ({
  options = [],
  onSearch,
  onSelect,
  searchPlaceholder = "Search for a product to add",
  minCharsToSearch = 3,
  debounceMs = 300,
  renderOption,
  emptyMessage = "No products found",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (typeof onSearch !== "function") {
      return;
    }

    if (!query.length || query.length < minCharsToSearch) {
      return;
    }

    const timer = setTimeout(() => {
      onSearch(query);
      setIsOpen(true);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [debounceMs, minCharsToSearch, onSearch, query]);

  const handleSelect = async (option) => {
    await onSelect?.(option);
    setQuery("");
    setIsOpen(false);
  };

  const shouldShowEmptyState = query.length >= minCharsToSearch;

  return (
    <div className="relative w-full" ref={containerRef}>
      <input
        type="text"
        className="w-full border rounded p-2 text-sm"
        placeholder={searchPlaceholder}
        value={query}
        onFocus={() => setIsOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          if (!e.target.value.length) {
            setIsOpen(false);
          }
        }}
      />

      {isOpen && (
        <div className="absolute z-20 w-full mt-2 bg-white border border-gray-300 rounded-md shadow-lg">
          <ul className="max-h-48 overflow-y-auto">
            {query.length < minCharsToSearch ? (
              <li className="px-4 py-2 text-gray-500">
                {`Type at least ${minCharsToSearch} chars`}
              </li>
            ) : options.length > 0 ? (
              options.map((option, index) => (
                <li
                  key={option.value || option.id || index}
                  onClick={() => handleSelect(option)}
                  className="px-4 py-2 cursor-pointer hover:!bg-blue-200"
                >
                  {renderOption ? renderOption(option) : option.label}
                </li>
              ))
            ) : shouldShowEmptyState ? (
              <li className="px-4 py-2 text-gray-500">{emptyMessage}</li>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
};
